import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import type { PersonResponse } from "~types/person";
import type { SearchFilterParams } from "../types/searchFilterParams";

const useFetchPersons = (params: SearchFilterParams) => {
  const request = useApi();
  const { organizationId, sport } = useParams();
  const url = `${sport}/o/${organizationId}/persons?${new URLSearchParams(params).toString()}`;

  return useQuery({
    queryKey: ["persons", sport, organizationId, params],
    queryFn: async () =>
      request<PersonResponse>(url).then((response) => ({ persons: response?.data || [], nextLink: response?.links?.next })),
  });
};

export default useFetchPersons;
